// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3MPEb","cell":"ColumnAccessor_cell__1Sa_9","firstCellAccent":"ColumnAccessor_firstCellAccent__3MMLx"};